/*
 * nadi-brand.js — the brand, on its own line, above a product card's name.
 *
 * WHY. Measured on the collection page at 375px: the card is 177px wide and
 * the title takes 118px of it — six lines of "שמפו מזין ומשקם הידרופלקס –
 * סדרה לבנה 1000 מ״ל | HAYDROPLEX White Series" — which pushes the price to
 * the bottom of the card. Sephora's card, selling the same Olaplex bottle,
 * reads "Olaplex" and then two lines of name. The brand is already in our
 * titles; it is just buried mid-sentence.
 *
 * WHY IT IS DONE HERE AND NOT IN LIQUID. The card comes from Kalles'
 * product-grid-item5.liquid. Editing a theme file means transcribing 9,707
 * bytes by hand, and a check against the deployed checksum showed the
 * transcription 23 bytes short — this repo's oldest failure mode, caught by
 * the rule that exists for it. The product page, which is ours, does use
 * Liquid (snippets/nadi-brand-line.liquid).
 *
 * NO LAYOUT SHIFT. The slot is reserved in CSS from first paint —
 * .t4s-pr-style5 .t4s-product-info__inner keeps 18px of padding at the top and
 * the line is absolutely placed into it — so filling it moves nothing. A
 * store whose CLS is already poor does not need 44 cards growing on load.
 *
 * THE RULE, the same one the Liquid version uses: a brand's leading word must
 * appear in the product's own title. The list is the store's collections,
 * printed once per page by snippets/nadi-brand-data.liquid. So the line can
 * only ever repeat a word already visible in the name — never a guess.
 */
(function () {
  'use strict';

  var BRANDS = (function () {
    var el = document.getElementById('NadiBrands');
    if (!el) return [];
    var raw;
    try { raw = JSON.parse(el.textContent) || []; } catch (e) { return []; }
    var out = [];
    for (var i = 0; i < raw.length; i++) {
      /* Brands only. The same list carries every collection, because the
         search panel matches those too — and matching them here put
         "מכונות גילוח" above a clipper. */
      if (raw[i][2] !== 1) continue;
      /* Cut at the first dash or pipe, whatever the spacing around it: the
         menu is not consistent — "הידרופלקס - haydroplex", "אולייר פריז-
         OLIERE PARIS", "ציטוזן | CITOZEN", "LEVEL 3  - לבל 3". Splitting on
         " - " alone left the whole English tail on the card. A name with
         neither separator ("MRD", "SOS Envie") is used whole. */
      var name = String(raw[i][0]).split('-')[0].split('|')[0].trim();
      var head = name.split(' ')[0];
      if (head.length < 3) continue;
      /* Lower-cased for the comparison only: the menu says "JETEX" and the
         product says "Jetex Crafter". Hebrew is unaffected either way. */
      out.push({ name: name, needle: head.toLowerCase(), handle: raw[i][1] });
    }
    return out;
  })();

  /* NOT ON THE BRAND'S OWN SHELF. On /collections/הידרופלקס every card would
     otherwise repeat "הידרופלקס" 43 times, which is 43 lines of no
     information. The page's own h1 says where you are. */
  var HERE = (function () {
    if (document.body.className.indexOf('template-collection') === -1) return '';
    var h1 = document.querySelector('h1');
    if (!h1) return '';
    return h1.textContent.split('-')[0].split('|')[0].trim().split(' ')[0].toLowerCase();
  })();

  function brandFor(title) {
    var lc = title.toLowerCase();
    for (var i = 0; i < BRANDS.length; i++) {
      if (lc.indexOf(BRANDS[i].needle) !== -1) return BRANDS[i];
    }
    return null;
  }

  function paint(card) {
    if (card.dataset.nadiBrand) return;
    var info = card.querySelector('.t4s-product-info__inner');
    var titleEl = card.querySelector('.t4s-product-title');
    if (!info || !titleEl) return;
    card.dataset.nadiBrand = '1';
    var hit = brandFor(titleEl.textContent.trim());
    if (!hit || (HERE && hit.needle === HERE)) return;
    var a = document.createElement('a');
    a.className = 'nadi-brand nadi-brand--card';
    a.href = '/collections/' + encodeURIComponent(hit.handle);
    a.textContent = hit.name;
    info.insertBefore(a, info.firstChild);
  }

  function run() {
    if (!BRANDS.length) return;
    document.querySelectorAll('.t4s-pr-style5').forEach(paint);
  }

  run();
  /* Cards arrive late on this theme: infinite scroll, filter changes and the
     quick-view all rebuild them. Same answer as the cart bar reached — watch
     rather than assume, and keep it idempotent. */
  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; run(); }, 120);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
